import {init, captureException, captureMessage, ErrorBoundary} from "@sentry/react";
import Build from "../../Data/Build";

import(/* webpackPreload: true, webpackChunkName: "sentry" */'./LazySentry');
// import './LazySentry';

init({
    dsn: "https://ad19db56a9954295b425107b8d7941b0@o452185.ingest.sentry.io/5439236",

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // integrations: [
    //     //
    // ],

    attachStacktrace: true,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    tracesSampleRate: 0.5,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        "localhost",
        /^https:\/\/getsoapy.com\/api/
    ],

    allowUrls: [
        /https:\/\/((app|embed)\.)?getsoapy\.com/
    ],

    release: Build
});

export {
    ErrorBoundary,
    captureException,
    captureMessage,
}
